export class StatisticBarModel {
  name: string;
  series: Array<BarValueModel>;
}

export class BarValueModel {
  name: string;
  value: number;
}
